module.exports = __webpack_public_path__ + "static/media/useCases.0ffed080.png";